"use client"
import styled from "@emotion/styled"
import "swiper/css"
import { Container, NewText } from "ui"
import { extractProperty } from "utils"

const StyledContainer = styled.div`
  margin-top: 32px;
  background: white;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 80px;
  }
  p {
    padding: 0;
    margin: 0;
  }
`
type Props = {
  data: any
  isStepAValid: any
}

export const TitleContent: React.FC<Props> = ({ data, isStepAValid }) => {
  const title = extractProperty(data, "title")
  const content = extractProperty(data, "content")
  return (
    <Container>
      <StyledContainer>
        <NewText
          desktopFontSize={32}
          desktopFontWeight="400"
          desktopLineHeight="36px"
          mobileFontSize={24}
          mobileFontWeight="400"
          mobileLineHeight={"28px"}
          component="h2"
          tabIndex={0}
          color={isStepAValid() ? "black" : "#6F6F6F"}
        >
          {title}
        </NewText>
        <NewText
          desktopFontSize={16}
          desktopFontWeight="400"
          desktopLineHeight="23px"
          mobileFontSize={14}
          mobileFontWeight="400"
          mobileLineHeight={"20px"}
          component="div"
          color={isStepAValid() ? "black" : "#6F6F6F"}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </StyledContainer>
    </Container>
  )
}
export default TitleContent
